import React from 'react';
import Component from '@vfuk/core-interaction';
const Interaction = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default Interaction;
